import React, { useRef, useState } from "react";
import {
  Box,
  Container,
  Paper,
  Button,
  Typography,
  Chip,
  Grid,
  Rating,
  Stack,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";

export default function ProductDetails() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);

  const togglePlay = () => {
    if (!videoRef.current) return;

    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  // Dynamic product packs
  const packs = ["12 Pack × 60", "1 Pack × 60", "1 Pack × 28"];

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* PRODUCT SECTION */}
      <Paper
        elevation={3}
        sx={{
          borderRadius: { xs: "24px", md: "40px" },
          p: { xs: 2, md: 4 },
        }}
      >
        <Grid container spacing={4} alignItems="stretch">
          {/* LEFT IMAGE */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                bgcolor: "primary.main",
                borderRadius: "32px",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 4,
              }}
            >
              <Box
                component="img"
                src="/images/image-box.png"
                alt="Baby Wipes"
                sx={{
                  maxWidth: "60%",
                  height: "auto",
                }}
              />
            </Box>
          </Grid>

          {/* RIGHT CONTENT */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography variant="h4" fontWeight={700} gutterBottom>
                Original Baby Wipes
              </Typography>

              <Rating value={5} readOnly size="small" />

              <Stack direction="row" spacing={1} mt={2} flexWrap="wrap">
                <Chip label="Everyday Diaper Changes" color="primary" />
                <Chip label="Sensitive Skin" variant="outlined" />
              </Stack>

              <Typography sx={{ mt: 2, color: "text.secondary" }}>
                Best for sensitive, newborn and premature baby skin and perfect
                for everyday changing.
              </Typography>

              {/* INGREDIENTS */}
              <Box mt={3}>
                <Typography fontWeight={600}>Ingredients</Typography>
                <Typography variant="body2" color="text.secondary">
                  • Water (Aqua) 99.9% <br />
                  • Citrus Grandis (Grapefruit) Seed Extract
                </Typography>
              </Box>

              {/* BENEFITS */}
              <Box mt={3}>
                <Typography fontWeight={600}>Benefits</Typography>
                <Typography variant="body2" color="text.secondary">
                  ✓ Suitable for newborns & premature babies <br />
                  ✓ Approved by Allergy UK <br />
                  ✓ Vegan & cruelty free
                </Typography>
              </Box>

              {/* PRODUCT VARIANTS */}
              <Box mt={4}>
                <Typography fontWeight={600} mb={1}>
                  Products
                </Typography>

                {/* Professional Dynamic Grid */}
                <Grid container spacing={2}>
                  {packs.map((item) => (
                    <Grid item key={item} xs={6} sm={4} md="auto">
                      <Paper
                        sx={{
                          p: 2,
                          borderRadius: 3,
                          textAlign: "center",
                          minWidth: 120,
                          cursor: "pointer",
                          "&:hover": {
                            boxShadow: 6,
                          },
                        }}
                      >
                        {item}
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* VIDEO SECTION */}
      <Paper
        elevation={3}
        sx={{
          borderRadius: { xs: "24px", md: "40px" },
          overflow: "hidden",
          mt: 4,
        }}
      >
        <Box
          sx={{
            width: "100%",
            aspectRatio: "16 / 9",
            position: "relative",
          }}
        >
          <video
            ref={videoRef}
            src="/images/home-1.mp4"
            autoPlay
            muted
            loop
            playsInline
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />

          {/* PLAY / PAUSE BUTTON */}
          <Button
            onClick={togglePlay}
            variant="contained"
            sx={{
              position: "absolute",
              bottom: 24,
              left: 24,
              borderRadius: "50%",
              minWidth: 56,
              height: 56,
            }}
          >
            {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
